import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class InvoiceDepartmentModel extends ModelBase<InvoiceDepartmentModel, InvoiceDepartmentDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = InvoiceDepartmentModel.DEFAULT_ID;

    @observable
    public displayName: string = InvoiceDepartmentModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = InvoiceDepartmentModel.DEFAULT_ID;
        this.displayName = InvoiceDepartmentModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: InvoiceDepartmentDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: InvoiceDepartmentDTO[]): InvoiceDepartmentModel[] {
        const types: InvoiceDepartmentModel[] = [];

        for (const dto of dtos) {
            const model = new InvoiceDepartmentModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface InvoiceDepartmentDTO {
    id: string;
    displayName: string;
}
